/* -------------------------------------------------------------------------- */
/*                            Schema User Notifications                       */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';
export const userNotification = new schema.Entity(
  'userNotifications',
  {},
  { idAttribute: 'notificationId' }
);
export const userNotifications = new schema.Array(userNotification);
